import { render, staticRenderFns } from "./TheAside.vue?vue&type=template&id=44bd8161"
import script from "./TheAside.vue?vue&type=script&lang=js"
export * from "./TheAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports